import { useToast } from "vue-toast-notification";

export function showToast(message, type = "success", position = "bottom-left") {
  const toast = useToast();
  toast.open({
    message,
    type,
    position,
    duration: 4000,
    showCloseButton: false,
    dangerouslyUseHTMLString: true,
  });
}
